var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1983_37087)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1983_37087",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V46H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1983_37087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85439 0.044698C2.15955 0.162045 1.60087 0.457759 1.05157 1.00694C0.568002 1.49041 0.295701 1.95041 0.140772 2.56062C0.046875 2.91735 0.046875 3.18021 0.046875 22.7631C0.046875 42.4445 0.046875 42.6041 0.140772 42.9749C0.441241 44.1672 1.31448 45.0684 2.53514 45.4439L2.88725 45.5519L10.2816 45.5659C14.3473 45.5753 17.784 45.5659 17.9154 45.5519C18.6807 45.4627 19.1455 44.6694 18.8403 43.9794C18.7464 43.7588 18.4835 43.4959 18.2675 43.4021C18.1783 43.3598 16.2722 43.341 10.6337 43.3223L3.12199 43.2988L2.9342 43.1955C2.69007 43.0641 2.46472 42.8294 2.37551 42.6088C2.30979 42.4492 2.3004 40.4261 2.3004 22.7631V3.09572L2.39899 2.88449C2.51166 2.64511 2.70415 2.46674 2.98115 2.34C3.15955 2.25551 3.77457 2.25082 18.8966 2.25082H34.6243L34.8356 2.34939C35.0985 2.46674 35.2394 2.59817 35.3661 2.83756L35.4694 3.02531L35.4929 13.1876L35.5164 23.3498L35.615 23.561C35.8121 23.9835 36.1689 24.2135 36.6337 24.2182C37.1032 24.2182 37.4647 23.9835 37.6478 23.561L37.7464 23.331L37.737 13.0374L37.7229 2.74368L37.5962 2.36817C37.4084 1.82368 37.1642 1.43409 36.737 1.00694C36.3098 0.5798 35.9201 0.335718 35.3755 0.147963L34.9999 0.0212286L19.0375 0.0165347C10.2581 0.0118408 2.97645 0.0259225 2.85439 0.044698Z",
    fill: "#512C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2255 9.6915C5.88278 9.81354 5.57762 10.2031 5.51189 10.5974C5.47433 10.8462 5.5917 11.2405 5.7701 11.4564C5.84992 11.5503 6.01424 11.677 6.1363 11.738L6.36165 11.8507H16.2208C27.0753 11.8507 26.2771 11.8742 26.634 11.5503C26.8828 11.3297 26.9955 11.0762 26.9955 10.7335C26.9955 10.2735 26.7795 9.9262 26.3617 9.73375L26.1269 9.62109L16.2678 9.62579C8.00485 9.62579 6.38043 9.63518 6.2255 9.6915Z",
    fill: "#512C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24841 16.0674C6.1639 16.0956 6.00897 16.1941 5.91038 16.2786C5.21085 16.8654 5.49254 18.0107 6.38456 18.2031C6.72258 18.2735 23.3705 18.2735 23.7085 18.2031C24.5536 18.0247 24.8681 17.0249 24.2907 16.3819C23.9198 15.9688 24.7648 16.0017 15.0277 16.0064C8.37986 16.0064 6.37047 16.0205 6.24841 16.0674Z",
    fill: "#512C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24865 22.3105C6.16415 22.3387 6.00922 22.4372 5.91063 22.5217C5.2064 23.1132 5.49748 24.2632 6.39419 24.4462C6.5726 24.4838 8.50217 24.4979 12.9106 24.4885L19.1782 24.4744L19.3707 24.3711C19.6242 24.235 19.8918 23.9205 19.9576 23.6811C20.089 23.193 19.8872 22.6719 19.4646 22.4091L19.2346 22.2683L12.8214 22.2589C7.86368 22.2542 6.37072 22.2636 6.24865 22.3105Z",
    fill: "#512C9D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46C22.9247 46 18 41.0753 18 35C18 28.9247 22.9247 24 29 24C35.0753 24 40 28.9247 40 35C40 41.0753 35.0753 46 29 46ZM29 43.8C31.3339 43.8 33.5722 42.8729 35.2225 41.2225C36.8729 39.5722 37.8 37.3339 37.8 35C37.8 32.6661 36.8729 30.4278 35.2225 28.7775C33.5722 27.1271 31.3339 26.2 29 26.2C26.6661 26.2 24.4278 27.1271 22.7775 28.7775C21.1271 30.4278 20.2 32.6661 20.2 35C20.2 37.3339 21.1271 39.5722 22.7775 41.2225C24.4278 42.8729 26.6661 43.8 29 43.8ZM23.5 36.1H33.4V38.3H29V41.6L23.5 36.1ZM29 31.7V28.4L34.5 33.9H24.6V31.7H29Z",
    fill: "#512C9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1983_37087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRejected);
export default __webpack_public_path__ + "static/media/DocumentRejected.f1520766b82f7bd05eba70cf40a8052a.svg";
export { ForwardRef as ReactComponent };